import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';
import { ListItem } from './Item';

export const List = styled.div`
  ${(props) => {
    let spacing = '0rem';
    let borderRadius;
    const variant = props.variant || 'standard';
    if (variant === 'cards') {
      spacing = '0.5rem';
      borderRadius = { size: 300 };
    }
    if (props.spacing) spacing = props.spacing;
    return css`
      ${mixin.verticalFlow({ spacing })}
      & > ${ListItem} {
        ${borderRadius && mixin.borderRadius(borderRadius)}
      }
    `;
  }}
  ${({ spacing, variant }) =>
    (variant !== 'cards' || spacing === '0rem') &&
    css`
      & > div:not(:first-child) {
        border-top: 0;
      }
    `}
`;

export default List;
